import $ from 'jquery';
window.$ = $;

// hack for webpack with webpack.ProvidePlugin
let windowJquery = 'jQuery';
window[windowJquery] = $;


import moduleShareBlockInit from './modules/share-block-init'
import moduleNewsBlockHeight from './modules/news-block-height'
import moduleTabs from './modules/tabs'
import moduleMenu from './modules/menu'
import searchBlock from './modules/search-block'
import moduleTextSlider from './modules/text-slider'
import moduleFirstLetter from './modules/first-letter'
import mudulePhotoSlider from './modules/photo-slider'

// set of existing modules
let modules = {
    'tabs': moduleTabs,
    'menu': moduleMenu,
    'news-block-height': moduleNewsBlockHeight,
    'text-slider': moduleTextSlider,
    'share-block-init': moduleShareBlockInit,
    'first-letter': moduleFirstLetter,
    'photo-slider': mudulePhotoSlider,
    'search-block': searchBlock
};

// init global modules direct
/*moduleNewsBlockHeight.init();*/


// init target modules
if (window.appModules) {
    window.appModules.forEach(function(moduleName) {
        modules[moduleName].init()
    });
}
